import { Injectable } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { FuseConfirmationService } from "@fuse/services/confirmation";

@Injectable({
	providedIn: "root",
})
export class Confirm {
	constructor(
        private _formBuilder: UntypedFormBuilder,
        private confirmService: FuseConfirmationService,
	) {

    }

 public openDialog : UntypedFormGroup;

openPopup(message, icon,label){
      this.openDialog = this._formBuilder.group(
        {
            "title": label,
            "message": message,
            "icon": {
            "show": true,
            "name": icon,
            // "name": "mat_outline:cancel_schedule_send",
            "color": "warn"
            },
            "actions": {
                "confirm": {
                    "show": true,
                    "label": label,
                    "color": "warn"
                },
                "cancel": {
                    "show": true,
                    "label": "Cancel"
                }
            },
            "dismissible": true
        }
    );
    return this.confirmService.open(this.openDialog.value);
 }
 
}

